import Button from 'components/base/Button';
import { Col, Form, Row } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { SalvarMedicoDTO, TipoConselho } from 'hooks/useMedicos';

interface MedicoFormProps {
    onSubmit: (data: SalvarMedicoDTO) => void;
    initialData?: SalvarMedicoDTO;
    isSubmitting: boolean;
    id: string;
}

const MedicoForm = ({
    onSubmit,
    initialData,
    isSubmitting,
    id
}: MedicoFormProps) => {
    const form = useForm<SalvarMedicoDTO>({
        defaultValues: initialData || {
            nome: '',
            uf: '',
            registro: '',
            tipoConselho: TipoConselho.CRM
        }
    });

    return (
        <FormProvider {...form}>
            <Form noValidate onSubmit={form.handleSubmit(onSubmit)} id={id}>
                <Row className="g-5">
                    <Col xs={12} xl={8}>
                        <h4 className="mb-3">Informações do Médico</h4>
                        <Row className="g-3">
                            <Form.Group as={Col} xs={12} md={8}>
                                <Form.Label>Nome</Form.Label>
                                <Form.Control
                                    placeholder="Nome do médico"
                                    {...form.register('nome', { required: 'Nome é obrigatório' })}
                                    isInvalid={!!form.formState.errors.nome}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {form.formState.errors.nome?.message}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} xs={12} md={4}>
                                <Form.Label>UF</Form.Label>
                                <Form.Control
                                    placeholder="UF"
                                    {...form.register('uf', { required: 'UF é obrigatório' })}
                                    isInvalid={!!form.formState.errors.uf}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {form.formState.errors.uf?.message}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} xs={12} md={6}>
                                <Form.Label>Conselho</Form.Label>
                                <Form.Select
                                    {...form.register('tipoConselho', {
                                        valueAsNumber: true
                                    })}
                                >
                                    {Object.entries(TipoConselho)
                                        .filter(([_, value]) => typeof value === 'number')
                                        .map(([key, value]) => (
                                            <option key={value as number} value={value as number}>
                                                {key}
                                            </option>
                                        ))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group as={Col} xs={12} md={6}>
                                <Form.Label>Registro</Form.Label>
                                <Form.Control
                                    placeholder="Número do Registro"
                                    {...form.register('registro', {
                                        required: 'Registro é obrigatório'
                                    })}
                                    isInvalid={!!form.formState.errors.registro}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {form.formState.errors.registro?.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </FormProvider>
    );
};

export default MedicoForm; 